import React, { useEffect, useState } from "react";
import Image from "next/legacy/image";
import { useRouter } from "next/router";
import vinyl from "../images/vinyl.webp";
const PageTransitionLoader = () => {
  const [isLoading, setLoading] = useState(false);
  const router = useRouter();
  const Threshold = 100;

  useEffect(() => {
    let timer;

    const start = () => (timer = setTimeout(() => setLoading(true), Threshold));

    const end = () => {
      if (timer) {
        clearTimeout(timer);
      }
      setLoading(false);
    };

    router.events.on("routeChangeStart", start);
    router.events.on("routeChangeComplete", end);
    router.events.on("routeChangeError", end);

    return () => {
      router.events.off("routeChangeStart", start);
      router.events.off("routeChangeComplete", end);
      router.events.off("routeChangeError", end);

      if (timer) {
        clearTimeout(timer.current);
      }
    };
  }, [router.events]);

  if (!isLoading) return null;

  return (
    <div className="navigation-loader">
      <div className="navigation-loader__content">
        <p>
          <strong>Loading...</strong>
        </p>
        <div className="navigation-loader__img">
          <Image
            alt="Loading-image"
            src={vinyl}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </div>
  );
};

export default PageTransitionLoader;
